import { Component, OnInit, ViewChild } from '@angular/core'; 
import { Mailing } from '../../shared/models/mailing';
import { Brand } from '../../shared/models/brand';
import { MailingService } from '../../shared/services/mailing.service';
import { BrandService } from '../../shared/services/brand.service';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SpinnerService } from '../../shared/components/spinner/spinner.service';
import { ValidationService } from '../../shared/services/validation.service';

declare var $: any;

@Component({
  selector: 'app-mailings',
  templateUrl: './mailings.component.html'
})

export class MailingsComponent implements OnInit{
   
  public brands: Brand[];
  public selectedDateFilter;

  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<Mailing>();
  displayedColumns: string[] = ['name', 'status', 'brand', 'startDate', 'createdBy', 'createDate'];
  dateRanges: { [key: string]: Object }[] = [
    //{ Value: 1, Text: "Last month" },
    //{ Value: 3,  Text: "Last 3 months" },
    { Value: 6, Text: "Last 6 months"},
    { Value: 12, Text: "Last 12 months" },
    { Value: 24, Text: "Last 24 months"}
  ];
  mailingForm: FormGroup;
  submitted = false;
   
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private mailingService: MailingService, private brandService: BrandService, private router: Router, private formBuilder: FormBuilder, private spinnerService: SpinnerService) { }

  // init
  ngOnInit() {

    // show spinner on page load
    this.spinnerService.show();

    this.selectedDateFilter = 6;
    this.getMailings(this.selectedDateFilter);
    this.getBrands();

    this.mailingForm = this.formBuilder.group({
      name: ['', [Validators.required, ValidationService.alphaNumericValidator]],
      brandId: ['', Validators.required],
      startDate: ['', Validators.required]
    });
     
  }
 
  // add mailing
  add(name: string, brandId: number, startDate: string): void {
    name = name.trim();
    brandId = +brandId;

    if (!name || !brandId) { return; }
    this.mailingService.add({ name: name, brandId: brandId, startDate } as Mailing)
      .subscribe(mailing => {
        this.dataSource.data.push(mailing);
        this.hideAddMailingModal();
        this.router.navigate(['/mailing/' + mailing.id]);
      });
  }

  // hide modal
  hideAddMailingModal(): void {
    $("#addMailingModal").modal('hide');
  }
  // convenience getter for easy access to form fields

  onSubmitForm() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.mailingForm.invalid) {
      return;
    }
    
    // display form values on success
    //var jsonObj = JSON.stringify(this.mailingForm.value, null, 4);
    this.add(this.mailingForm.value["name"], +this.mailingForm.value["brandId"], this.mailingForm.value["startDate"]);
    this.resetForm();
  }

  resetForm() {
    this.submitted = false;
    this.mailingForm.reset();
  }

  // get data
  getMailings(filter: number): void {
    this.spinnerService.show();
    let filterValue = new Date(); 
    filterValue.setMonth(filterValue.getMonth() - filter);

    // get all mailings
    this.mailingService.getAll(filterValue.toDateString()).subscribe(result => {
       
      if (result.length) {
        this.dataSource.data = result;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
      // hide spinner
      setTimeout(() => {
        this.spinnerService.hide();
      }, 1500); 
    }, error => console.error(error));
  }

  // get brands
  getBrands(): void {
    // get all master brands
    this.brandService.getActiveBrands().subscribe(brandsResult => {
      if (brandsResult.length) {
        this.brands = brandsResult;
      }
    }, error => console.error(error)); 
  }

  // filter results by keyword
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // filter results by date
  applyDateFilter(event: Event) { 
    const filterValue = (event.target as HTMLInputElement).value;
    this.getMailings(+filterValue);
  }
} 
